const vehicleStorageTypes = ['vehicle-storage', 'car-storage', 'boat-storage', 'rv-storage', 'motorcycle-storage'];

function resultStorageType(type) {
  if (type === 'self-storage') return 'self-storage';
  if (vehicleStorageTypes.includes(type)) return 'vehicle-storage';
  return null;
}

export function initialProfileStorageType(dataset, hash) {
  if (dataset.resultsArrival !== 'true') return 'all';
  // A fragment preserves AJAX-selected results context without indexable query URLs.
  const fragmentType = new URLSearchParams((hash || '').replace(/^#/, '')).get('storage-type');
  return resultStorageType(fragmentType) || resultStorageType(dataset.initialStorageType) || 'all';
}

export function profileResultsLink(path, storageType) {
  const type = resultStorageType(storageType);
  if (!path || !type) return path;
  return `${path.split('#', 1)[0]}#storage-type=${type}`;
}
